import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import { authService } from "../services";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";

const EvolvRewards = () => {
  const [loading, setLoading] = useState(false);

  const [optInAll, setOptInAll] = useState(false);
  const [isContactByEmail, setIsContactByEmail] = useState(false);
  const [isContactBySMS, setIsContactBySMS] = useState(false);
  const [isContactByAppNotification, setIsContactByAppNotification] =
    useState(false);
  const [dob, setDob] = useState("");
  const [isTermsConditionAccepted, setIsTermsConditionAccepted] =
    useState(false);

  const [termsError, setTermsError] = useState("");
  const [errors, setErrors] = useState({});

  const navigate = useNavigate();

  const location = useLocation();
  const formData = location.state || {};


  
  // ********* For All Checked  *********
  const handleOptInAll = () => {
    const newState = !optInAll;
    setOptInAll(newState);
    setIsContactByEmail(newState);
    setIsContactBySMS(newState);
    setIsContactByAppNotification(newState);
  };

  // ************* For Error Message Check And Uncheck ************************
  useEffect(() => {
    if (isTermsConditionAccepted) {
      setTermsError("");
    }

    if (dob) {
      setErrors("");
    }
  }, [isTermsConditionAccepted, dob]);


  // ********* For All Email Contact Notification Checkbox  *********
  useEffect(() => {
    if (isContactByEmail && isContactBySMS && isContactByAppNotification) {
      setOptInAll(true);
    } else {
      setOptInAll(false);
    }
  }, [isContactByEmail, isContactBySMS, isContactByAppNotification]);


  // *********  Default check *********
  useEffect(() => {
    setOptInAll(true);
    setIsContactByEmail(true);
    setIsContactBySMS(true);
    setIsContactByAppNotification(true);
  }, []);
  

  // ******* Final CMS SIGNUP API *******
  const handleJoin = async () => {
    if (!isTermsConditionAccepted) {
      setTermsError("You must agree to the terms and conditions.");
      return;
    }
    setTermsError(""); // Clear error if checkbox is checked
    if (!dob) {
      setErrors("Date of Birth is required.");
      return;
    }
    setErrors(""); //

    setLoading(true);


    // ******* DATE FORMAT *******
    const formatDateToMMDDYYYY = (date) => {
      if (!date) return null;

      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();

      return `${month}/${day}/${year}`;
    };

    const payload = {
      firstName: formData.firstName ?? "",
      surName: formData.surName ?? "",
      email: formData.email ?? "",
      password: formData.password ?? "",
      phone: formData.phone ?? "",
      postCode: "",
      dob: dob ? formatDateToMMDDYYYY(dob) : "",
      deviceType: "web",
      deviceToken: "web",
      streetAddress1: "",
      streetAddress2: "",
      city: "",
      isMarketingConsent: false,
      promocode: formData.promocode ?? "",
      favoriteLocationId: 0,
      isContactBySMS: Boolean(isContactBySMS),
      isContactByEmail: Boolean(isContactByEmail),
      isContactByAppNotification: Boolean(isContactByAppNotification),
      isTermsConditionAccepted: Boolean(isTermsConditionAccepted),
      // specialityPrefrences: formData.specialityPrefrences ?? [],
      // locationPrefrences: formData.locationPrefrences ?? [],
      // cuisinePrefrences: formData.cuisinePrefrences ?? [],
      specialityPrefrences:
        formData.specialityPrefrences[0] === 0
          ? []
          : formData.specialityPrefrences ?? [],
      locationPrefrences:
        formData.locationPrefrences[0] === 0
          ? []
          : formData.locationPrefrences ?? [],
      cuisinePrefrences:
        formData.cuisinePrefrences[0] === 0
          ? []
          : formData.cuisinePrefrences ?? [],
    };
    console.log("Form Data Final Submit:", payload);

    try {
      const response = await authService.signUpService(payload);
      setLoading(false);

      if (response.success) {
        toast.success("Sign up Successfully");
        //  await callQuadSignUp(response.data);
        navigate("/login");
      } else {
        toast.error(response.message || "Something went wrong.");
      }
    } catch (err) {
      setLoading(false);
      toast.error(err.message);
    }
  };

  return (
    <div className="landing-container mobile-css2">
      <div className="container">
        {/* LOGO */}
        <div className="logo-container mobile-css">
          <img src="/images/mainLogo.png" alt="Logo" className="mian-logo" />
        </div>

        <div className="rewards-signup">
          {/* Description */}
          <div className="text-center text-white mb-4">
            <h2>How would you like us to communicate with you?</h2>
          </div>

          {/* CheckBox */}
          <div className="label-text12">
            <h5 className="text-white text-start">Opt in for all</h5>
            <div className="form-check form-switch">
              <input
                type="checkbox"
                className="form-check-input"
                id="selectAll"
                checked={optInAll}
                onChange={handleOptInAll}
              />
              <label
                className="form-check-label text-white"
                htmlFor="selectAll"
              >
                Select All
              </label>
            </div>
          </div>

          <h6 className="text-white text-start">
            Get short, time-sensitive alerts about special promotions or
            last-minute offers:
          </h6>

          <div className="three-check-box">
            <div className="form-check form-switch">
              <input
                type="checkbox"
                className="form-check-input"
                id="email"
                checked={isContactByEmail}
                onChange={() => setIsContactByEmail(!isContactByEmail)}
              />
              <label className="form-check-label text-white" htmlFor="email">
                By Email
              </label>
            </div>

            <div className="form-check form-switch">
              <input
                type="checkbox"
                className="form-check-input"
                id="sms"
                checked={isContactBySMS}
                onChange={() => setIsContactBySMS(!isContactBySMS)}
              />
              <label className="form-check-label text-white" htmlFor="sms">
                By SMS Alert
              </label>
            </div>

            <div className="form-check form-switch">
              <input
                type="checkbox"
                className="form-check-input"
                id="app"
                checked={isContactByAppNotification}
                onChange={() =>
                  setIsContactByAppNotification(!isContactByAppNotification)
                }
              />
              <label className="form-check-label text-white" htmlFor="app">
                By App Notifications
              </label>
            </div>
          </div>


           {/* Date PICKER */}
          <div className="three-check-box-text">
            <h5 className="mt-4 text-start one-time">One last thing…</h5>

            <div className="birth-date-ds1">
              <label>Date of birth</label>

              <div className="LocalizationProvider">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DesktopDatePicker
                    format="DD/MM/YYYY"
                    value={dob ? dayjs(dob, "YYYY-MM-DD") : null}
                    onChange={(date) => {
                      if (!dayjs(date).isValid()) return;

                      const selectedDate = new Date(date);
                      const today = new Date();

                      // Age validation (18+)
                      let age =
                        today.getFullYear() - selectedDate.getFullYear();
                      const m = today.getMonth() - selectedDate.getMonth();
                      const d = today.getDate() - selectedDate.getDate();
                      const isBirthdayPassed = m > 0 || (m === 0 && d >= 0);
                      if (!isBirthdayPassed) age--;

                      if (age < 18) {
                        setErrors({
                          ...errors,
                          dob: "You must be 18 years or older",
                        });
                      } else {
                        setErrors({ ...errors, dob: "" });
                      }

                      // Save in raw ISO format (YYYY-MM-DD) for consistency
                      const rawDate = dayjs(date).format("YYYY-MM-DD");
                      setDob(rawDate);
                    }}
                    maxDate={dayjs().subtract(18, "year")}
                    disableMaskedInput
                    slotProps={{
                      textField: {
                        // variant: "standard",
                        fullWidth: false,
                        className: "form-control w-50",
                        placeholder: "DD/MM/YYYY",
                        error: Boolean(errors.dob),
                        helperText: errors.dob || "",
                      },
                    }}
                  />
                </LocalizationProvider>
              </div>
            </div>

            <p className="small text-start">
              So we can also send you a gift on your birthday. We also need to
              verify that you are over 18+.
            </p>
            <div className="form-check box-design-ch">
              <input
                type="checkbox"
                className="form-check-input"
                id="terms"
                checked={isTermsConditionAccepted}
                onChange={() =>
                  setIsTermsConditionAccepted(!isTermsConditionAccepted)
                }
              />
              {/* <label className="form-check-label text-start" htmlFor="terms">
                By ticking this box you agree to Evolv Rewards <a href="https://www.danddlondon.com/tcs/">terms and
                conditions.</a>
              </label> */}
              <label className="form-check-label text-start" htmlFor="terms">
                By ticking this box you agree to Evolv Rewards{" "}
                <a
                  href="https://www.danddlondon.com/tcs/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  terms and conditions.
                </a>
              </label>
            </div>
            {termsError && (
              <small className="text-danger rv1">{termsError}</small>
            )}
          </div>
        </div>

        {/* Button */}
        <div className="last-join-bt text-center">
          <button
            className="sign-up-button last-time1"
            onClick={handleJoin}
            disabled={loading}
            //  disabled={!isTermsConditionAccepted}
          >
            {/* JOIN */}
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
              </>
            ) : (
              "JOIN"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EvolvRewards;
